import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { ClassDuration, ClassDurationsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ClassDurationsDataService {

  private uri: string = `${environment.apiUrl}class-durations`;
  private cacheKey: string = 'classDurations.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getClassDuration(id: number): Observable<ClassDuration|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getClassDurations(parameters: {[param: string]: string | string[]}): Observable<ClassDurationsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addClassDuration(data: ClassDuration): Observable<ClassDuration|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addClassDurations(data: ClassDuration[]): Observable<ClassDuration[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateClassDuration(data: ClassDuration): Observable<ClassDuration|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateClassDurations(data: ClassDuration[]): Observable<ClassDuration[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchClassDuration(data: ClassDuration): Observable<ClassDuration|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchClassDurations(data: ClassDuration[]): Observable<ClassDuration[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteClassDuration(data: ClassDuration): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteClassDurations(data: ClassDuration[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((classDuration) => {
      ids.push(classDuration.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
